/**
 * Clerk Authentication Reset Utility
 * 
 * EMERGENCY DEBUGGING ONLY - This utility is for development debugging
 * when Clerk authentication gets into an inconsistent state.
 * 
 * Usage: Open browser console and run window.resetClerkAuth()
 */

export const resetClerkAuth = () => {
  console.log('🔧 Resetting Clerk authentication state...');
  
  // Clear all localStorage
  if (typeof window !== 'undefined') {
    // Clear Clerk-specific items
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('clerk') || 
          key.startsWith('__clerk') || 
          key.startsWith('_clerk') ||
          key.includes('clerk')) {
        localStorage.removeItem(key);
        console.log(`Removed localStorage: ${key}`);
      }
    });
    
    // Clear sessionStorage
    Object.keys(sessionStorage).forEach(key => {
      if (key.startsWith('clerk') || 
          key.startsWith('__clerk') || 
          key.startsWith('_clerk') ||
          key.includes('clerk')) {
        sessionStorage.removeItem(key);
        console.log(`Removed sessionStorage: ${key}`);
      }
    });
    
    // Clear any custom app tokens as well
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('phoneVerified');
    localStorage.removeItem('isInSignupFlow');
    
    console.log('✅ Clerk authentication state reset complete');
    
    // Force page reload to reinitialize Clerk
    setTimeout(() => {
      console.log('🔄 Reloading page to reinitialize Clerk...');
      window.location.reload();
    }, 500);
  }
};

export const isClerkBrowserError = (error) => {
  return error && (
    error.message?.includes('Unable to authenticate this browser') ||
    error.message?.includes('Browser unauthenticated') ||
    error.message?.includes('development instance')
  );
};

// Add this to window for easy debugging
if (typeof window !== 'undefined') {
  window.resetClerkAuth = resetClerkAuth;
  console.log('🔧 Clerk reset utility available: window.resetClerkAuth()');
} 